// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-list-card {
  --border-style: none;
  --inner-border-width: 0px;
  margin: 5px 0px;
  box-shadow: rgba(99, 99, 99, 0.3) 0px 0px 4px 1px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/modals/already-session/already-session.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,yBAAA;EACA,eAAA;EACA,iDAAA;AACJ","sourcesContent":[".item-list-card {\r\n    --border-style: none;\r\n    --inner-border-width: 0px;\r\n    margin: 5px 0px;\r\n    box-shadow: rgba(99, 99, 99, 0.3) 0px 0px 4px 1px;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
